// Free packs are claimed elsewhere, not bought.
export const canBuyPack = ({
  canPurchase,
  effectivePrice,
}: {
  canPurchase: boolean;
  effectivePrice: number;
}) => canPurchase && effectivePrice !== 0;
